export const RoutsData = {
  DEFAULT: {path: '/', name: 'DEFAULT'},
  LOGIN: {path: '/login', name: 'LOGIN'},
  INITIATOR: {path: '/initiator', name: 'INITIATOR'},
  COMPANY_ROOT: {path: '/company', name: 'COMPANY_ROOT'},
  COMPANY_LIST: {path: 'list', name: 'COMPANY_LIST'},
  USER_ROOT: {path: '/user', name: 'USER_ROOT'},
  USER_LIST: {path: 'list', name: 'USER_LIST'},

  EVENT_ROOT: {path: '/event', name: 'EVENT_ROOT'},
  EVENT_LIST: {path: 'list', name: 'EVENT_LIST'},
  EVENT_ADD: {path: 'add', name: 'EVENT_ADD'},
  EVENT_SHOW_ROOT: {path: ':eventId', name: 'EVENT_SHOW_ROOT'},

  VIDEO_CHANNEL_ROOT: {path: '/video-channel', name: 'VIDEO_CHANNEL_ROOT'},
  VIDEO_CHANNEL_LIST: {path: 'list', name: 'VIDEO_CHANNEL_LIST'},
  VIDEO_CHANNEL_ADD: {path: 'add', name: 'VIDEO_CHANNEL_ADD'},
  VIDEO_CHANNEL: {path: ':channelId', name: 'VIDEO_CHANNEL'},

  VIDEO_ROOT: {path: '/video', name: 'VIDEO_ROOT'},
  VIDEO_LIST: {path: 'list', name: 'VIDEO_LIST'},
  VIDEO_ADD: {path: 'add', name: 'VIDEO_ADD'},
  VIDEO: {path: ':videoId', name: 'VIDEO'},

  CHANNEL_ROOT: {path: '/channel', name: 'CHANNEL_ROOT'},
  CHANNEL_LIST: {path: 'list', name: 'CHANNEL_LIST'},
  CHANNEL_ADD: {path: 'add', name: 'CHANNEL_ADD'},
  CHANNEL: {path: ':channelId', name: 'CHANNEL'},

  TICKET_CATEGORY: {path: '/ticket-category', name: 'TICKET_CATEGORY'},
  TICKET_CATEGORY_LIST: {path: 'list', name: 'TICKET_CATEGORY_LIST'},
  TICKET_CATEGORY_ADD: {path: 'add', name: 'TICKET_CATEGORY_ADD'}
};
